import { invoicesListTypes } from './actionTypes';

const INIT_STATE = {
  invoicesListData: [],
  milestoneConfig: [],
  CountItems: 0,
  isLoading: false,
  error: {},
};

const invoicesList = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case invoicesListTypes.GET_INVOICES_LIST:
      return {
        ...state,
        isLoading: true,
      };
    case invoicesListTypes.GET_INVOICES_LIST_SUCCESS:
      return {
        ...state,
        invoicesListData: action.payload.InvoiceData,
        CountItems: action.payload.CountItems,
        isLoading: false,
      };

    case invoicesListTypes.GET_INVOICES_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    case invoicesListTypes.GET_MILESTONESCONFIG_IN_SUCCESSS:
        return{
          ...state,
          milestoneConfig: action.payload
        }
  
    case invoicesListTypes.GET_MILESTONESCONFIG_IN_FAIL:
          return{
            ...state,
            error: action.payload,
          }

    default:
      return state;
  }
};

export default invoicesList;
